/** Hard server admission bounds for one decoded thread-history response. */
export const THREAD_HISTORY_RESPONSE_MAX_DECODED_BYTES = 1024 * 1024;
export const THREAD_HISTORY_RESPONSE_MAX_MESSAGE_COUNT = 200;

/** Speculative detail admission budget, excluding the selected thread. */
export const THREAD_HISTORY_PREWARM_MAX_THREADS = 3;
export const THREAD_HISTORY_PREWARM_MAX_DECODED_BYTES = 1024 * 1024;
export const THREAD_HISTORY_PREWARM_PROTOCOL_RESERVE_BYTES = 16 * 1024;

/**
 * One reusable client window fits three speculative subscriptions under the cumulative cap.
 * The reserve covers the small protocol envelope around each decoded thread snapshot.
 */
export const THREAD_HISTORY_CLIENT_WINDOW_MAX_DECODED_BYTES = Math.floor(
  (THREAD_HISTORY_PREWARM_MAX_DECODED_BYTES - THREAD_HISTORY_PREWARM_PROTOCOL_RESERVE_BYTES) /
    THREAD_HISTORY_PREWARM_MAX_THREADS,
);
export const THREAD_HISTORY_CLIENT_WINDOW_MAX_MESSAGE_COUNT = 80;
